if (!customElements.get('product-checkbox')) {
  class ProductCheckbox extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector('.product-checkbox__input');
      this.required = this.dataset.required === 'true';

      if (this.checkbox) {
        this.initCheckbox();
      }
    }

    initCheckbox() {
      // Si le champ est requis, on ajoute un écouteur d'événement pour valider le formulaire
      if (this.required) {
        const form = document.getElementById(this.checkbox.getAttribute('form'));
        if (form) {
          form.addEventListener('submit', this.validateForm.bind(this));
        }
      }
    }

    validateForm(event) {
      if (this.required && !this.checkbox.checked) {
        event.preventDefault();
        this.showError();
      }
    }

    showError() {
      // Ajouter une classe d'erreur pour mettre en évidence la case à cocher
      this.classList.add('error');

      // Créer un message d'erreur s'il n'existe pas déjà
      if (!this.querySelector('.product-checkbox__error')) {
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('product-checkbox__error');
        errorMessage.textContent = 'Ce champ est requis';
        this.appendChild(errorMessage);

        // Supprimer le message d'erreur lorsque la case est cochée
        this.checkbox.addEventListener('change', () => {
          if (this.checkbox.checked) {
            this.classList.remove('error');
            errorMessage.remove();
          }
        });
      }
    }
  }

  customElements.define('product-checkbox', ProductCheckbox);
}
